export default "__VITE_ASSET__B1F7HVxR__"